import React from "react";
import "./consignment-details.scss";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Paper from "@material-ui/core/Paper";
import { withRouter } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import {connect} from "react-redux";

const useStyles = makeStyles((theme) => ({
    table: {},
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
}));

const ConsignmentDetails = ({ consignment }) => {
    const classes = useStyles();

    const createRows = (label, value) => ({ label, value });
    let rows = [];
    if(consignment){
        rows.push(createRows("Shipment Id:", consignment.id));
        rows.push(createRows("Order Id:", consignment.orderId));
        rows.push(createRows("Quantity(dispatched):", `${consignment.quantity} Kg`));
        rows.push(createRows("Quantity(Measured):", `${consignment.quantityMeasured} Kg`));
        rows.push(createRows("Price/Kg:", `Rs ${consignment.pricePerKg.toFixed(2)}`));
        rows.push(
            createRows("Amount:", `Rs ${(consignment.quantity * consignment.pricePerKg).toFixed(2)}`)
        );
        rows.push(
            createRows(
                "Amount(measured):",
                `Rs ${(consignment.quantityMeasured * consignment.pricePerKg).toFixed(2)}`
            )
        );
        rows.push(
            createRows(
                "Dispatched On:",
                consignment.dispatchedOn.toDate().toLocaleDateString()
            )
        );
        rows.push(
            createRows(
                "Arrived On:",
                consignment.arrivedOn.toDate().toLocaleDateString()
            )
        );
        rows.push(createRows("Status:", consignment.status));
    }

    return !consignment?(""):(
        <Container style={{ maxWidth: 650 }}>
            <Paper className={classes.paper}>
                <Typography variant={"h6"}>Shipment details</Typography>
                <TableContainer>
                    <Table
                        className={classes.table}
                        size="small"
                        aria-label="a dense table"
                    >
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.label}>
                                    <TableCell component="th" scope="row">
                                        {row.label}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.value}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Container>
    );
};
const mapStateToProps = ({common})=>({
    consignment: common.current
});
export default withRouter(connect(mapStateToProps)(ConsignmentDetails));
